import { array, bool, func, object } from 'prop-types'
import { Component } from 'react'
import { findDOMNode } from 'react-dom'
import AssignedUser from './AssignedUser'
import UnassignedUser from './UnassignedUser'

class UserAssigner extends Component {
  static propTypes = {
    assignee: object,
    content: object,
    createIntegrationTask: func,
    disabled: bool,
    loadIntegrationTask: func,
    onSelectAssignee: func,
    onUnassignUser: func,
    people: array,
    proxyUser: object,
    task: object,
  }

  constructor(props) {
    super(props)
    this.state = {
      focused: false,
      isUsingKeyboard: false,
    }
  }

  componentDidUpdate() {
    if (this.state.isUsingKeyboard && this.state.focused) {
      const trigger =
        // eslint-disable-next-line react/no-find-dom-node
        findDOMNode(this).querySelector('.kuiper-unassignedUser-trigger') ||
        // eslint-disable-next-line react/no-find-dom-node
        findDOMNode(this).querySelector('.kuiper-avatar-wrapper')
      if (trigger) trigger.focus()
    }
  }

  onFocusComponent = (isUsingKeyboard) => {
    this.setState({ focused: true, isUsingKeyboard })
  }

  onBlurComponent = () => {
    this.setState({ focused: false, isUsingKeyboard: false })
  }

  onSelectAssignee = (assignee, eventType) => {
    this.setState(
      () => ({ isUsingKeyboard: eventType === 'keyPress' }),
      () => {
        this.props.onSelectAssignee(assignee)
      }
    )
  }

  onUnassignUser = (eventType) => {
    this.setState(
      () => ({ isUsingKeyboard: eventType === 'keyPress' }),
      () => {
        this.props.onUnassignUser()
      }
    )
  }

  render() {
    if (this.props.assignee) {
      return (
        <AssignedUser
          assignee={this.props.assignee}
          content={this.props.content}
          createIntegrationTask={this.props.createIntegrationTask}
          disabled={this.props.disabled}
          loadIntegrationTask={this.props.loadIntegrationTask}
          onBlur={this.onBlurComponent}
          onFocus={this.onFocusComponent}
          onUnassignUser={this.onUnassignUser}
          proxyUser={this.props.proxyUser}
          task={this.props.task}
        />
      )
    }
    return (
      <UnassignedUser
        disabled={this.props.disabled}
        onAssignUser={this.onSelectAssignee}
        onBlur={this.onBlurComponent}
        onFocus={this.onFocusComponent}
        people={this.props.people}
      />
    )
  }
}

export default UserAssigner
